import { fromString } from "@bounce/date"
import { DEFAULT_LANGUAGE } from "@bounce/i18n"
import type { PostCardProps } from "@bounce/web-components"

import type { CityLink } from "@/libs/bounce/cities"
import type { FormattedAnyGuidePreview, FormattedBlogPostPreview } from "@/libs/prismic/types"

/**
 * Map a blog post to a post card props
 */
export const blogPostToPostCard = (blogPost: FormattedBlogPostPreview): PostCardProps => ({
  title: blogPost.title,
  excerpt: blogPost.excerpt,
  image: blogPost.image,
  href: blogPost.url,
  date: fromString(blogPost.datePublished).toFormat("d MMMM"),
  author: blogPost.author,
})

/**
 * Check if a keyword is included in a blog post
 */
export const blogPostIncludes = (blogPost: FormattedBlogPostPreview, keywords: string) => {
  const text = keywords.toLowerCase()
  const title = blogPost.title.toLowerCase()
  const excerpt = blogPost.excerpt.toLowerCase()

  return title.includes(text) || excerpt.includes(text)
}

type City = {
  slug: string
  translated?: boolean
  translatedName: string
}

/**
 * Map city link to a link to the city guides page
 */
export const cityToGuidesLink = (city: City) => ({
  href: `/guides/${city.slug}`,
  locale: city.translated ? undefined : DEFAULT_LANGUAGE,
  name: city.translatedName,
})

/**
 * Filter out the cities that don't have any guides
 */
export const getCitiesWithGuides = (cities: CityLink[], guides: FormattedAnyGuidePreview[]) => {
  return cities
    .map(city => ({
      ...city,
      guides: guides.filter(g => g.city === city.slug).length,
    }))
    .filter(city => !!city.guides)
}
